export const en = {
  common: {
    reserve: "Reserve a seat",
    birthdayWall: "Birthday Wall",
    backHome: "Back to home",
    loading: "Loading…",
    seatsLeft: "{n} seats left",
    full: "Full",
    sets: "sets",
    guests: "guests",
    person: "guests",
    cancel: "Cancel",
    close: "Close",
    submit: "Submit",
    required: "Required",
    openMap: "Open map",
    minutes: "min",
    save: "Save",
  },
  nav: {
    schedule: "Schedule",
    giveaways: "Giveaways",
    notes: "Good to know",
    faq: "FAQ",
    location: "Location",
    wall: "Birthday Wall",
    reserve: "Reserve",
  },
  hero: {
    badge: "HBD Bogummy · 16/6/2026",
    title: "Park Bo-gum 박보검\nHappy Birthday 2026",
    subtitle: "Let’s enjoy a Sandwich Birthday Party",
    venue: "at Gumm&Kalee Café",
    dateRange: "14–16 June 2026",
    intro:
      "Celebrate Park Bo-gum’s birthday with a special 3-day event, 3 rounds a day — please read all the details before reserving.",
    cta: "Reserve now",
    ctaWall: "Write a wish",
  },
  schedule: {
    title: "3-Day Schedule",
    subtitle: "14–16 June 2026 · 3 rounds/day · seating only until your round ends",
    roundWord: "Round",
    checkIn: "Queue check-in",
    quotaBadgeN: "First {n} sets ordered get a Special Giveaway",
    luckyBadge: "Buy 2 sets → prize draw",
    seeReserve: "Reserve this round",
  },
  giveaway: {
    title: "Giveaways & Prizes",
    specialTitle: "Special Giveaway",
    specialDesc:
      "Special Giveaway for the earliest buyers in each round — 14 Jun: first 20 sets per round; 15 & 16 Jun: first 10 sets per round (ranked by order and payment made at the counter only; queue tickets are handed out at the venue 30 minutes before each round, unrelated to advance registration).",
    luckyTitle: "Prize draw (buy 2 sets)",
    luckyDesc: "Buy 2 sets to earn an entry into that day’s special prize draw.",
    perDayTitle: "Daily prizes",
    shirt: "Authentic ‘Be with You’ shirt ×1",
    ginseng: "Everytime Red Ginseng ×1 box + Postcard",
    shampoo: "Dr.Forhair Shampoo — Pokémon Limited Edition",
    dayWord: "",
  },
  notes: {
    title: "Before you come",
    items: [
      "Queue check-in opens 30 minutes before each round (08:30 / 11:30 / 14:30).",
      "Please arrive on time for your round; you may be up to 30 minutes late. After that your seat is forfeited and given to walk-ins at the venue (if seats remain).",
      "We ask that guests in each round sit and join the activities only within their round's scheduled time.",
      "Sandwich Birthday Set is 1 set per person (seats = number of sets).",
      "The café clears the space after each round so the next round's guests can use the venue.",
    ],
  },
  faq: {
    title: "Frequently asked questions",
    items: [
      { q: "Do I need to reserve in advance?", a: "We recommend reserving to secure your seat. Walk-ins are admitted 30 min after a round starts if seats remain." },
      { q: "Is the seat reservation linked to the Special Giveaway?", a: "No. Reserving a seat each round is only for the café to manage seating internally and keep things convenient for guests — it is not tied to ordering a Sandwich Set or to the Special Giveaway." },
      { q: "How many seats per reservation?", a: "Enter your number of guests (= number of sets). One set serves one person." },
      { q: "Is there a booking fee?", a: "There is no fee or deposit to reserve. It simply holds a seat so the café can estimate attendance and prepare enough for each round." },
      { q: "How do I change or cancel?", a: "Use the link in your confirmation email to view or cancel. Cancelling instantly frees the seats for others." },
      { q: "Didn’t get the confirmation email?", a: "Check your Junk/Spam folder or keep your on-screen code, and contact staff to resend it." },
    ],
  },
  location: {
    title: "Venue",
    cafe: "Gumm&Kalee Café",
    desc: "Get directions and find the café on Google Maps.",
    button: "Open in Google Maps",
  },
  reserve: {
    title: "Reserve a seat",
    subtitle: "Fill in your details to reserve. We’ll email you a confirmation.",
    name: "Full name",
    phone: "Phone number",
    email: "Email",
    emailHint: "Used to send your confirmation",
    partySize: "Number of guests (sets)",
    day: "Choose a day",
    round: "Choose a round",
    pickDayFirst: "Please choose a day first",
    submit: "Confirm reservation",
    submitting: "Reserving…",
    selectRound: "— select a round —",
    maxPartyNote: "Up to {n} guests per reservation",
    errors: {
      name: "Please enter your name",
      phone: "Please enter a valid phone number",
      email: "Please enter a valid email",
      slot: "Please choose a day and round",
      turnstile: "Please verify you’re not a bot",
      full: "Sorry, this round is full. Please pick another round.",
      generic: "Something went wrong. Please try again.",
    },
    successTitle: "Reserved!",
    successDesc: "We’ve emailed your confirmation. Please save this reservation code.",
    yourCode: "Your reservation code",
    emailSent: "Confirmation email sent",
    emailSkipped: "Email isn’t enabled yet — please save your code.",
    emailFailed: "Email failed to send — please save your code and contact staff.",
    manageLink: "Manage / cancel link",
    reserveAnother: "Reserve another",
    screenshotTip: "Save the QR or screenshot this to show on the day.",
    saveImage: "Save QR image",
    qrHint: "Scan or save this QR to open your reservation.",
  },
  manage: {
    title: "Your reservation",
    status: "Status",
    confirmed: "Confirmed",
    cancelled: "Cancelled",
    cancelBtn: "Cancel reservation",
    cancelling: "Cancelling…",
    cancelConfirm: "Cancel this reservation? The seats will be released to others.",
    cancelledMsg: "Your reservation has been cancelled. Thank you!",
    notFound: "Reservation not found — the link may be invalid.",
  },
  wall: {
    title: "Birthday Wall",
    subtitle: "Send a photo or message for Park Bo-gum. Posts appear on the in-café board after staff review.",
    nameLabel: "Your name (optional)",
    messageLabel: "Your message",
    photoLabel: "Attach a photo (optional)",
    choosePhoto: "Choose a photo",
    post: "Send your wish",
    posting: "Sending…",
    pendingMsg: "Sent! Your post will appear on the board after staff review.",
    emptyErr: "Please add a message or a photo.",
    emptyGallery: "No wishes shown yet — be the first!",
    galleryTitle: "Latest wishes",
    seeAll: "See all wishes",
    rateLimited: "You’re posting too often. Please wait a moment.",
    tooLarge: "Image file is too large.",
  },
  wishes: {
    title: "All wishes",
    sortLatest: "Latest",
    sortLiked: "Most liked",
    empty: "No wishes shown yet — be the first!",
    end: "You’ve reached the end 💛",
    likeRateLimited: "Too many likes for now. Please wait a moment.",
  },
  admin: {
    title: "Admin · Event console",
    password: "Password",
    login: "Log in",
    loggingIn: "Logging in…",
    badPassword: "Incorrect password",
    logout: "Log out",
    tabStats: "Seat overview",
    tabReservations: "Reservations",
    tabWall: "Wall moderation",
    tabTools: "Tools",
    totalBookings: "Total bookings",
    totalGuests: "Total guests",
    slot: "Round",
    booked: "Booked",
    remaining: "Free",
    capacity: "Capacity",
    bookings: "bookings",
    quota: "Giveaway quota",
    search: "Search name/phone/email/code",
    filterSlot: "All days/rounds",
    exportCsv: "Download CSV",
    name: "Name",
    phone: "Phone",
    email: "Email",
    size: "Sets",
    status: "Status",
    emailStatus: "Email",
    actions: "Actions",
    resend: "Resend email",
    save: "Save",
    edit: "Edit",
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",
    approve: "Approve",
    reject: "Reject",
    noPending: "No posts awaiting review",
    wallQrTitle: "Birthday Wall QR",
    wallQrDesc: "Print and display in the café for guests to scan and post.",
    boardLink: "Open board screen (for projection)",
    downloadQr: "Download QR",
    boardSettings: "Board screen settings",
    boardSettingsDesc: "Set how long the board stays in single-card vs card-wall mode.",
    boardCardMinutes: "Single-card mode (minutes)",
    boardWallMinutes: "Card-wall mode (minutes)",
    boardCardAdvance: "Swap card every (seconds)",
    saveSettings: "Save settings",
    settingsSaved: "Saved",
  },
  board: {
    empty: "Waiting for the first wish… scan the QR to share the love.",
    scanToPost: "Scan to post a wish",
  },
  footer: {
    unofficial: "Unofficial fan-made event",
    developedBy: "Developed by",
  },
} as const;
